module.exports = __webpack_public_path__ + "static/img/logo.4220319.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/headerImg/logo.png
// module id = 1gzZ
// module chunks = 1